// Generated by LiveScript 1.6.0
var ref$, each, reject, sortBy, reg, comp, wat, dir, domQuery, getParam, isDigit, replaceTrailingDigits, deepClone, SYM, MUTATORS, i$, len$, m, proxyComputed, syncDirectives, syncNode, syncClone, ifOrIfNot, rewriteCloneKeys, removeOldItems, initializeArray, findPlaceholder, cloneFrom, updateArrayItem, sortArrayItems, callLeaf, callObject, callArray, callAll, runComputed, updateComputed, update, reactive, batch, bootstrap;
ref$ = require('./fn'), each = ref$.each, reject = ref$.reject, sortBy = ref$.sortBy;
reg = require('./registry');
comp = require('./computed');
wat = require('./watchers');
dir = require('./directives');
domQuery = require('./dom-query');
ref$ = require('./utils'), getParam = ref$.getParam, isDigit = ref$.isDigit, replaceTrailingDigits = ref$.replaceTrailingDigits, deepClone = ref$.deepClone;
SYM = Symbol['for']('@en/prefix');
MUTATORS = {};
for (i$ = 0, len$ = (ref$ = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse', 'fill', 'copyWithin']).length; i$ < len$; ++i$) {
  m = ref$[i$];
  MUTATORS[m] = true;
}
proxyComputed = function(ctx, value, key, parent, prop){
  var cloned;
  if (typeof value === 'function') {
    ctx.computedResultFns.add(value);
    return value;
  } else {
    cloned = deepClone(value);
    if (key != null && parent != null && prop != null) {
      return reactive(ctx, cloned, key, parent, prop);
    } else {
      return cloned;
    }
  }
};
syncDirectives = function(ctx, el, skipCond, skipMark){
  return ctx.directives.forEach(function(entry, name){
    var isParametric, raw, key, idx, ref$, value, parent, prop;
    isParametric = entry.isParametric;
    if (skipMark && name === 'mark') {
      return;
    }
    if (skipCond && (name === 'if' || name === 'ifnot')) {
      return;
    }
    if (raw = el.getAttribute(ctx.prefix + name)) {
      key = isParametric ? (idx = raw.indexOf(':'), idx >= 0 ? raw.slice(0, idx) : raw) : raw;
      if (key.endsWith('.#')) {
        key = key.slice(0, -2);
      }
      ref$ = domQuery.getValue(ctx, key), value = ref$.value, parent = ref$.parent, prop = ref$.prop;
      if (parent != null) {
        return update(ctx, value, key, false, parent, prop, {
          directive: name,
          el: el,
          skipCond: skipCond,
          skipMark: skipMark
        });
      }
    }
  });
};
syncNode = function(ctx, el, isRoot){
  var children, i$, to$, i;
  children = el.children;
  for (i$ = 0, to$ = children.length; i$ < to$; ++i$) {
    i = i$;
    syncNode(ctx, children[i], false);
  }
  return syncDirectives(ctx, el, isRoot, false);
};
syncClone = function(ctx, el){
  var children, i$, to$, i;
  children = el.children;
  for (i$ = 0, to$ = children.length; i$ < to$; ++i$) {
    i = i$;
    syncClone(ctx, children[i]);
  }
  reg.scanAndRegister(ctx.registry, el, ctx);
  return syncDirectives(ctx, el, false, true);
};
ifOrIfNot = function(ctx, el, value, key, condType){
  var isShow, isTpl, attrType, attrMark, children, siblings, current, next, temp, i$, to$, i, m, results$ = [];
  isShow = (function(){
    switch (condType) {
    case 'if':
      return value != null && value !== false && value !== 0;
    case 'ifnot':
      return value == null || value === false || value === 0;
    }
  }());
  isTpl = el instanceof HTMLTemplateElement;
  attrType = ctx.prefix + condType;
  attrMark = ctx.prefix + 'mark';
  if (isShow && isTpl) {
    children = Array.from(el.content.children);
    if (children.length > 0) {
      each(function(child){
        var x$, clone;
        x$ = clone = child.cloneNode(true);
        x$.setAttribute(attrType, key);
        reg.scanTree(ctx.registry, clone, ctx);
        syncNode(ctx, clone, true);
        return el.before(clone);
      })(
      children);
      reg.unregisterElement(ctx.registry, el);
      el.remove();
    }
  }
  if (!isShow && !isTpl && el.parentNode != null) {
    siblings = [el];
    current = el;
    for (;;) {
      next = current.nextElementSibling;
      if (next == null) {
        break;
      }
      if (next.getAttribute(attrType) !== key) {
        break;
      }
      siblings.push(next);
      current = next;
    }
    temp = document.createElement('template');
    for (i$ = 0, to$ = siblings.length; i$ < to$; ++i$) {
      i = i$;
      temp.content.appendChild(siblings[i].cloneNode(true));
    }
    temp.setAttribute(attrType, key);
    if (m = el.getAttribute(attrMark)) {
      temp.setAttribute(attrMark, m);
    }
    for (i$ = 0, to$ = siblings.length; i$ < to$; ++i$) {
      i = i$;
      reg.unregisterElement(ctx.registry, siblings[i]);
    }
    el.replaceWith(temp);
    reg.scanAndRegister(ctx.registry, temp, ctx);
    for (i$ = 1, to$ = siblings.length; i$ < to$; ++i$) {
      i = i$;
      results$.push(siblings[i].remove());
    }
    return results$;
  }
};
rewriteCloneKeys = function(ctx, clone, key, phKey){
  var names, res$, i$, ref$, len$, n, rewrite, desc, to$, i, results$ = [];
  res$ = [];
  for (i$ = 0, len$ = (ref$ = Array.from(ctx.directives.keys())).length; i$ < len$; ++i$) {
    n = ref$[i$];
    res$.push(ctx.prefix + n);
  }
  names = res$;
  rewrite = function(el){
    var i$, to$, i, cur, results$ = [];
    for (i$ = 0, to$ = names.length; i$ < to$; ++i$) {
      i = i$;
      if (cur = el.getAttribute(names[i])) {
        if (cur.startsWith(phKey)) {
          results$.push(el.setAttribute(names[i], key + cur.slice(phKey.length)));
        }
      }
    }
    return results$;
  };
  rewrite(clone);
  desc = clone.querySelectorAll('*');
  for (i$ = 0, to$ = desc.length; i$ < to$; ++i$) {
    i = i$;
    results$.push(rewrite(desc[i]));
  }
  return results$;
};
removeOldItems = function(ctx, plc, phKey, attrMark){
  var prev, curr, k, results$ = [];
  prev = plc.previousElementSibling;
  while (prev != null) {
    curr = prev;
    prev = curr.previousElementSibling;
    if (k = curr.getAttribute(attrMark)) {
      if (k !== phKey && replaceTrailingDigits(k, '#') === phKey) {
        reg.unregisterElement(ctx.registry, curr);
        results$.push(curr.remove());
      } else {
        break;
      }
    }
  }
  return results$;
};
initializeArray = function(ctx, plc, phKey, array){
  var attrMark, tpl, ph, x$, html, prefix, tag, ref$, box, elements, i$, to$, i, clone, k;
  attrMark = ctx.prefix + 'mark';
  removeOldItems(ctx, plc, phKey, attrMark);
  if (plc instanceof HTMLTemplateElement) {
    tpl = plc;
    if (ph = plc.content.firstElementChild) {
      ph.setAttribute(attrMark, phKey);
    }
  } else {
    x$ = tpl = document.createElement('template');
    x$.innerHTML = plc.outerHTML;
    x$.setAttribute(attrMark, phKey);
    plc.replaceWith(tpl);
    ph = tpl.content.firstElementChild;
  }
  if (ph == null) {
    return [];
  }
  html = ph.outerHTML;
  prefix = phKey.slice(0, -2);
  tag = (ref$ = ph.tagName) != null ? ref$.toLowerCase() : void 8;
  box = tag === 'tr'
    ? document.createElement('tbody')
    : tag === 'td' || tag === 'th'
      ? document.createElement('tr')
      : document.createElement('div');
  elements = [];
  for (i$ = 0, to$ = array.length; i$ < to$; ++i$) {
    i = i$;
    box.innerHTML = html;
    if (clone = box.firstElementChild) {
      k = prefix === ''
        ? String(i)
        : prefix + "." + i;
      rewriteCloneKeys(ctx, clone, k, phKey);
      tpl.before(clone);
      syncClone(ctx, clone);
      elements.push(clone);
    }
  }
  return elements;
};
findPlaceholder = function(el, phKey, attrMark){
  var cur;
  cur = el.nextElementSibling;
  while (cur != null) {
    if (cur.getAttribute(attrMark) === phKey) {
      return cur;
    }
    cur = cur.nextElementSibling;
  }
  return null;
};
cloneFrom = function(ph){
  var ref$;
  switch (false) {
  case !(ph instanceof HTMLTemplateElement):
    return (ref$ = ph.content.firstElementChild) != null ? ref$.cloneNode(true) : void 8;
  default:
    return ph.cloneNode(true);
  }
};
updateArrayItem = function(ctx, key, idx, item, array){
  var attrMark, entries, markEntries, i$, to$, i, prefix, phKey, replaced, el, ph, cl, k, tpls, tpl, fc, clone, results$ = [];
  attrMark = ctx.prefix + 'mark';
  entries = ctx.registry.get(key) || [];
  markEntries = [];
  for (i$ = 0, to$ = entries.length; i$ < to$; ++i$) {
    i = i$;
    if (entries[i].directive === 'mark') {
      markEntries.push(entries[i]);
    }
  }
  if (markEntries.length > 0 && !(typeof item === 'object' && item !== null && SYM in item)) {
    return;
  }
  prefix = array[SYM] || '';
  phKey = replaceTrailingDigits(key, '#');
  replaced = false;
  for (i$ = 0, to$ = markEntries.length; i$ < to$; ++i$) {
    i = i$;
    el = markEntries[i].el;
    if (ph = findPlaceholder(el, phKey, attrMark)) {
      if (cl = cloneFrom(ph)) {
        k = prefix === ''
          ? idx
          : prefix + "." + idx;
        rewriteCloneKeys(ctx, cl, k, phKey);
        reg.unregisterElement(ctx.registry, el);
        el.replaceWith(cl);
        syncClone(ctx, cl);
        replaced = true;
      }
    }
  }
  if (!replaced) {
    tpls = document.querySelectorAll("[" + attrMark + "=\"" + phKey + "\"]");
    for (i$ = 0, to$ = tpls.length; i$ < to$; ++i$) {
      i = i$;
      tpl = tpls[i];
      if (tpl instanceof HTMLTemplateElement) {
        if (fc = tpl.content.firstElementChild) {
          clone = fc.cloneNode(true);
          k = prefix === ''
            ? idx
            : prefix + "." + idx;
          rewriteCloneKeys(ctx, clone, k, phKey);
          tpl.before(clone);
          results$.push(syncClone(ctx, clone));
        }
      }
    }
    return results$;
  }
};
sortArrayItems = function(ctx, array){
  var attrMark, prefix, tplKey, tplPre, tpls, i$, to$, t, tpl, items, prev, sorted, last, curr, k, idx, results$ = [];
  attrMark = ctx.prefix + 'mark';
  prefix = array[SYM] || '';
  tplKey = prefix === ''
    ? '#'
    : prefix + ".#";
  tplPre = tplKey.slice(0, -1);
  tpls = document.querySelectorAll("[" + attrMark + "=\"" + tplKey + "\"]");
  for (i$ = 0, to$ = tpls.length; i$ < to$; ++i$) {
    t = i$;
    tpl = tpls[t];
    items = [];
    prev = tpl.previousElementSibling;
    sorted = true;
    last = -1;
    while (prev != null) {
      curr = prev;
      prev = curr.previousElementSibling;
      if (k = curr.getAttribute(attrMark)) {
        if (k === tplKey) {
          break;
        }
        if (k.startsWith(tplPre)) {
          idx = parseInt(k.slice(tplPre.length), 10);
          if (!isNaN(idx)) {
            items.push({
              el: curr,
              idx: idx
            });
            if (sorted && last !== -1 && last !== idx + 1) {
              sorted = false;
            }
            last = idx;
          }
        }
      }
    }
    if (!sorted) {
      results$.push(each(fn$)(
      sortBy(fn1$)(
      items)));
    }
  }
  return results$;
  function fn$(it){
    return tpl.before(it.el);
  }
  function fn1$(it){
    return it.idx;
  }
};
callLeaf = function(ctx, value, key, isDel, parent, prop, cfg){
  var ref$, entry, entries, i$, to$, i, e, d, results$ = [];
  if (cfg != null) {
    if (cfg.skipMark && cfg.directive === 'mark') {
      return;
    }
    if (cfg.skipCond && ((ref$ = cfg.directive) === 'if' || ref$ === 'ifnot')) {
      return;
    }
    if (entry = ctx.directives.get(cfg.directive)) {
      return entry.cb({
        el: cfg.el,
        value: value,
        key: key,
        isDelete: isDel,
        parent: parent,
        prop: prop,
        param: getParam(cfg.el, ctx.prefix + cfg.directive, entry.isParametric)
      });
    }
  } else {
    entries = ctx.registry.get(key);
    if (entries != null) {
      for (i$ = 0, to$ = entries.length; i$ < to$; ++i$) {
        i = i$;
        e = entries[i];
        if (d = ctx.directives.get(e.directive)) {
          results$.push(d.cb({
            el: e.el,
            value: value,
            key: key,
            isDelete: isDel,
            parent: parent,
            prop: prop,
            param: e.param
          }));
        }
      }
      return results$;
    }
  }
};
callObject = function(ctx, value, key, isDel){
  var ks, i$, to$, i, k, childKey, results$ = [];
  ks = Object.keys(value);
  for (i$ = 0, to$ = ks.length; i$ < to$; ++i$) {
    i = i$;
    k = ks[i];
    childKey = key === ''
      ? k
      : key + "." + k;
    results$.push(callAll(ctx, value[k], childKey, isDel, value, k, false, null));
  }
  return results$;
};
callArray = function(ctx, value, key, isDel, parent, prop, cfg){
  var phKey, attrMark, query, targets, itemPre, lenKey, i$, to$, t, len, i, idx, itemKey, lenK;
  phKey = key + ".#";
  attrMark = ctx.prefix + 'mark';
  query = "[" + attrMark + "=\"" + phKey + "\"]";
  targets = Array.from((cfg != null ? cfg.el : void 8) != null
    ? (cfg.el.parentElement || document).querySelectorAll(query)
    : document.querySelectorAll(query));
  itemPre = key + ".";
  lenKey = key + ".length";
  ctx.registry.forEach(function(_, rk){
    if (rk.startsWith(itemPre) && rk !== lenKey) {
      return ctx.registry['delete'](rk);
    }
  });
  for (i$ = 0, to$ = targets.length; i$ < to$; ++i$) {
    t = i$;
    initializeArray(ctx, targets[t], phKey, value);
  }
  len = value.length;
  for (i$ = 0; i$ < len; ++i$) {
    i = i$;
    idx = String(i);
    itemKey = key === ''
      ? idx
      : key + "." + idx;
    callAll(ctx, value[idx], itemKey, isDel, value, idx, true, null);
  }
  lenK = key === ''
    ? 'length'
    : key + ".length";
  return callLeaf(ctx, len, lenK, isDel, value, 'length', null);
};
callAll = function(ctx, value, key, isDel, parent, prop, skipArr, cfg){
  var isPArr, isObjVal;
  isPArr = Array.isArray(parent);
  if (isPArr && isDigit(prop) && !skipArr) {
    if (!(cfg != null && cfg.skipMark)) {
      updateArrayItem(ctx, key, prop, value, parent);
    }
  } else if (isPArr && prop === 'length') {
    sortArrayItems(ctx, parent);
  }
  isObjVal = typeof value === 'object' && value !== null && SYM in value;
  if (isObjVal && Array.isArray(value)) {
    if (!(cfg != null && cfg.skipMark)) {
      return callArray(ctx, value, key, isDel, parent, prop, cfg);
    }
  } else if (isObjVal) {
    callObject(ctx, value, key, isDel);
    return callLeaf(ctx, value, key, isDel, parent, prop, cfg);
  } else {
    return callLeaf(ctx, value, key, isDel, parent, prop, cfg);
  }
};
runComputed = function(ctx, fn, key, parent, prop){
  var version, result, e;
  version = comp.bumpVersion(ctx, key);
  result = (function(){
    try {
      return fn();
    } catch (e$) {
      e = e$;
    }
  }());
  if (result instanceof Promise) {
    result.then(function(it){
      if (comp.isCurrent(ctx, key, version)) {
        return update(ctx, proxyComputed(ctx, it, key, parent, prop), key, false, parent, prop, null);
      }
    })['catch'](function(it){
      return console.error('[entropy] Async computed error at', key, it);
    });
  } else {
    return proxyComputed(ctx, result, key, parent, prop);
  }
};
updateComputed = function(ctx, changed){
  var deps, i$, to$, i, dep, results$ = [];
  deps = comp.getDependents(ctx, changed);
  for (i$ = 0, to$ = deps.length; i$ < to$; ++i$) {
    i = i$;
    dep = deps[i];
    results$.push(update(ctx, dep.computed, dep.key, false, dep.parent, dep.prop, null));
  }
  return results$;
};
update = function(ctx, value, key, isDel, parent, prop, cfg){
  var isComp, final, ver;
  if (ctx.destroyed) {
    return;
  }
  isComp = typeof value === 'function' && !ctx.computedResultFns.has(value);
  final = isComp ? runComputed(ctx, value, key, parent, prop) : value;
  if (isComp && final == null) {
    return;
  }
  if (final instanceof Promise) {
    ver = comp.bumpVersion(ctx, key);
    final.then(function(it){
      if (comp.isCurrent(ctx, key, ver)) {
        return update(ctx, it, key, false, parent, prop, cfg);
      }
    });
    return;
  }
  if (cfg == null) {
    wat.callWatchers(ctx, key, final, function(it){
      return domQuery.getValue(ctx, it).value;
    });
  }
  return callAll(ctx, final, key, isDel, parent, prop, false, cfg);
};
reactive = function(ctx, obj, prefix, parentOpt, propOpt){
  var isObj, isFn, parent, prop, proxied, ks, i$, to$, i, k, childKey;
  if (obj === null) {
    return obj;
  }
  isObj = typeof obj === 'object';
  isFn = typeof obj === 'function';
  parent = parentOpt != null ? parentOpt : null;
  prop = propOpt != null ? propOpt : null;
  if (isFn && parent) {
    obj = obj.bind(parent);
  }
  if (isObj || isFn) {
    Object.defineProperty(obj, SYM, {
      value: prefix,
      enumerable: false,
      writable: true,
      configurable: true
    });
  }
  if (isFn && prop && parent) {
    comp.setDependents(ctx, obj, prefix, parent, prop);
    return obj;
  }
  if (!isObj) {
    return obj;
  }
  proxied = new Proxy(obj, {
    get: function(t, p, r){
      var orig, d, v, res;
      if (typeof p === 'symbol') {
        return Reflect.get(t, p, r);
      }
      if (Array.isArray(t) && MUTATORS[p] && parent != null && prop != null) {
        orig = Reflect.get(t, p);
        return function(){
          var copy, res;
          copy = t.slice();
          res = orig.apply(copy, arguments);
          parent[prop] = copy;
          return res;
        };
      }
      if (ctx.deps.isEvaluating) {
        if (d = Object.getOwnPropertyDescriptor(t, p)) {
          if (d.enumerable) {
            ctx.deps.currentSet.add(prefix === ''
              ? p
              : prefix + "." + p);
          }
        }
      }
      v = Reflect.get(t, p, r);
      if (typeof v === 'function' && SYM in v && !ctx.computedResultFns.has(v)) {
        res = v();
        if (res instanceof Promise) {
          return res.then(function(it){
            if (typeof it === 'function') {
              ctx.computedResultFns.add(it);
              return it;
            } else {
              return deepClone(it);
            }
          });
        } else if (typeof res === 'function') {
          ctx.computedResultFns.add(res);
          return res;
        } else {
          return deepClone(res);
        }
      } else {
        return v;
      }
    },
    set: function(t, p, v, r){
      var key, rv, ok;
      if (typeof p === 'symbol') {
        return Reflect.set(t, p, v, r);
      }
      key = prefix === ''
        ? p
        : prefix + "." + p;
      rv = typeof v === 'object' && v !== null || typeof v === 'function' ? reactive(ctx, v, key, r, p) : v;
      ok = Reflect.set(t, p, rv, r);
      if (ctx.batchQueue != null) {
        ctx.batchQueue.push(function(){
          return update(ctx, rv, key, false, r, p, null);
        });
        ctx.batchQueue.push(function(){
          return updateComputed(ctx, key);
        });
      } else {
        update(ctx, rv, key, false, r, p, null);
        updateComputed(ctx, key);
      }
      return ok;
    },
    deleteProperty: function(t, p){
      var key, ok;
      if (typeof p === 'symbol') {
        return Reflect.deleteProperty(t, p);
      }
      key = prefix === ''
        ? p
        : prefix + "." + p;
      ok = Reflect.deleteProperty(t, p);
      update(ctx, void 8, key, true, t, p, null);
      comp.removeDependents(ctx, key);
      return ok;
    },
    defineProperty: function(t, p, d){
      if (p === SYM && SYM in t && typeof d.value === 'string' && /\.\d+$/.test(d.value)) {
        return Reflect.set(t, p, d.value);
      }
      return Reflect.defineProperty(t, p, d);
    }
  });
  ks = Object.keys(obj);
  for (i$ = 0, to$ = ks.length; i$ < to$; ++i$) {
    i = i$;
    k = ks[i];
    childKey = prefix === ''
      ? k
      : prefix + "." + k;
    obj[k] = reactive(ctx, obj[k], childKey, proxied, k);
  }
  return proxied;
};
batch = function(ctx, fn){
  var e, queue, i$, to$, i, results$ = [];
  ctx.batchQueue = [];
  try {
    fn();
  } catch (e$) {
    e = e$;
  }
  queue = ctx.batchQueue || [];
  ctx.batchQueue = null;
  for (i$ = 0, to$ = queue.length; i$ < to$; ++i$) {
    i = i$;
    results$.push(queue[i]());
  }
  return results$;
};
bootstrap = function(ctx){
  var x$;
  dir.registerBuiltins(ctx);
  x$ = ctx.directives;
  x$.set('if', {
    cb: function(arg$){
      var el, value, key;
      el = arg$.el, value = arg$.value, key = arg$.key;
      return ifOrIfNot(ctx, el, value, key, 'if', {
        isParametric: false
      });
    }
  });
  x$.set('ifnot', {
    cb: function(arg$){
      var el, value, key;
      el = arg$.el, value = arg$.value, key = arg$.key;
      return ifOrIfNot(ctx, el, value, key, 'ifnot', {
        isParametric: false
      });
    }
  });
  return x$;
};
module.exports = {
  reactive: reactive,
  update: update,
  batch: batch,
  bootstrap: bootstrap
};